export function hackRedirectUri(uri: string) {
  const url = new URL(uri);
  const currentUri = url.searchParams.get('redirect_uri');
  url.searchParams.set('redirect_uri', currentUri?.replace(/https:\/\/preprod\.donnons\.org/, window?.location?.origin) || '');
  console.log('Google auth uri was modified with local uri: %s', url.searchParams.get('redirect_uri'));
  return url.toString();
}
